'use strict';
// write your code here
var population = document.getElementsByClassName('population');
var arrPopulation = [];
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = population[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var value = _step.value;
        var num = value.textContent.split(',').join('');
        arrPopulation.push(+num);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}
var total = arrPopulation.reduce(function(acc, current) {
    return acc + current;
}, 0);
var strTotal = String(total).split('').reverse().join('');
var resultTotal = '';
for(var i = 0; i < strTotal.length; i += 3){
    resultTotal += strTotal.slice(i, i + 3);
    if (i + 3 < strTotal.length) resultTotal += ',';
}
var average = Math.round(total / arrPopulation.length);
var strAvr = String(average).split('').reverse().join('');
var resultAverage = '';
for(var i1 = 0; i1 < strAvr.length; i1 += 3){
    resultAverage += strAvr.slice(i1, i1 + 3);
    if (i1 + 3 < strAvr.length) resultAverage += ',';
}
var totalPopulation = document.querySelector('.total-population');
var averagePopulation = document.querySelector('.average-population');
totalPopulation.textContent = resultTotal.split('').reverse().join('');
averagePopulation.textContent = resultAverage.split('').reverse().join('');

//# sourceMappingURL=js_get_data_DOM.0a2fe33e.js.map
